import type { FaireBrandEntity } from "../../entity_types/brand";

export const starter_brand_be_home: FaireBrandEntity = {
  token: "starter_brand_be-home",
  type: "brand",
  name: "Be Home",
  logoUrl: "",
  minimumOrderDollars: 150,
  rating: 4.8,
  location: "US",
  tags: ["starter-collections"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
